import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { TitleSchema } from '../../_offline/models/title.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class TitleDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<TitleSchema> {
    return this.ipcSendSync(IPC_CHANNEL.TITLE.GET_ALL, this.tenantId);
  }

  putAll(titleSchema: TitleSchema): Observable<TitleSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.TITLE.PUT_ALL, titleSchema);
  }
}
